import { InputDescription } from '@//components/InputDescription';
import { InputLabel } from '@//components/InputLabel';
import { InputStateMessage } from '@//components/InputStateMessage';
import { Select, type SelectProps } from '@//components/Select';
import styles from './Selectfield.module.scss';

export interface SelectfieldProps extends Omit<SelectProps, 'id'> {
  id: string;
  label: string;
  ariaLabel?: string;
  description?: string;
  stateMessage?: string;
}

export const Selectfield = ({
  id,
  label,
  ariaLabel,
  description,
  stateMessage,
  placeholder,
  disabled,
  state,
  ...props
}: SelectfieldProps) => (
  <div className={styles.selectfield}>
    <InputLabel htmlFor={id}>{label}</InputLabel>
    <Select
      id={id}
      placeholder={placeholder}
      state={state}
      aria-label={ariaLabel || label}
      aria-describedby={
        [stateMessage ? `${id}-state-message` : null, description ? `${id}-description` : null]
          .filter(Boolean)
          .join(',') || undefined
      }
      {...props}
    />
    {description && <InputDescription id={`${id}-description`}>{description}</InputDescription>}
    {stateMessage && state && (
      <InputStateMessage id={`${id}-state-message`} state={state}>
        {stateMessage}
      </InputStateMessage>
    )}
  </div>
);
